import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-account-name-warning-dialog',
  templateUrl: './account-name-warning-dialog.component.html',
  styleUrls: ['./account-name-warning-dialog.component.scss'],
})
export class AccountNameWarningDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<AccountNameWarningDialogComponent>,
  ) {}

  onCancel(): void {
    this.dialogRef.close('cancel');
  }

  onSave(): void {
    this.dialogRef.close('openAccountNameDialog');
  }
}
